var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmoking = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.592 3.567a.75.75 0 0 1-.18 1.045c-.363.257-.602.564-.652.812-.028.139-.044.471.653.964.518.366.898.764 1.12 1.204.23.457.266.92.16 1.348-.196.788-.85 1.351-1.264 1.66a.75.75 0 0 1-.898-1.2c.389-.291.647-.583.706-.822a.42.42 0 0 0-.045-.312c-.075-.15-.251-.375-.645-.654-1-.707-1.441-1.574-1.257-2.485.162-.803.772-1.396 1.257-1.74a.75.75 0 0 1 1.045.18",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M22.592 3.567a.75.75 0 0 1-.18 1.045c-.363.257-.602.564-.652.812-.028.139-.044.471.653.964.518.366.898.764 1.12 1.204.23.457.266.92.16 1.348-.196.788-.85 1.351-1.264 1.66a.75.75 0 0 1-.898-1.2c.389-.291.647-.583.706-.822a.42.42 0 0 0-.045-.312c-.075-.15-.251-.375-.645-.654-1-.707-1.441-1.574-1.257-2.485.162-.803.772-1.396 1.257-1.74a.75.75 0 0 1 1.045.18M21.75 14A1.75 1.75 0 0 0 20 12.25H2A1.75 1.75 0 0 0 .25 14v3c0 .966.784 1.75 1.75 1.75h18A1.75 1.75 0 0 0 21.75 17zM20 13.75a.25.25 0 0 1 .25.25v3a.25.25 0 0 1-.25.25H2a.25.25 0 0 1-.25-.25v-3a.25.25 0 0 1 .25-.25z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.75 13a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75m16.5 0a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75",
  clipRule: "evenodd"
})));
export default SvgSmoking;